import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { BasicDialog } from '../../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../../components/Form/FormComponents';
import { bulkTearsheetGenerationModalOpenState } from './bulkTearsheetGenerationState';
import { BulkTearsheetGenerationForm } from './BulkTearsheetGenerationForm';

interface BulkTearsheetGenerationModalProps {
  onRefresh?: () => void;
}

export function BulkTearsheetGenerationModal({ onRefresh }: BulkTearsheetGenerationModalProps) {
  const [open, setOpen] = useAtom(bulkTearsheetGenerationModalOpenState);
  const onClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <BasicDialog open={open} onClose={onClose} title='Bulk Generate Tearsheets'>
      <FormFieldsContainer>
        {open && <BulkTearsheetGenerationForm onClose={onClose} onRefresh={onRefresh} />}
      </FormFieldsContainer>
    </BasicDialog>
  );
}
